import { useCallback, useEffect, useState, Dispatch, SetStateAction } from 'react';
import { useInputOnChangeValue } from 'src/commons/hooks';
import { useSelectOnChangeValue } from 'src/commons/hooks/useSelectOnChangeValue';
import { PublicationFilters } from '../types';

interface UseFiltersLogicProps {
  filter: PublicationFilters;
  onChangeFilter: Dispatch<SetStateAction<PublicationFilters>>;
}

const getStatusFromPublicationStateId = (publicationStateId: string) => {
  if (publicationStateId === '1') return 'activa';
  if (publicationStateId === '2') return 'inactiva';
  return '';
};

const getPublicationStateIdFromStatus = (status: string) => {
  if (status === 'activa') return '1';
  if (status === 'inactiva') return '2';
  return '';
};

export const useFiltersLogic = ({ filter, onChangeFilter }: UseFiltersLogicProps) => {
  const [search, setSearch] = useState(filter.search);
  const [status, setStatus] = useState(() =>
    getStatusFromPublicationStateId(filter.publication_state_id),
  );
  const [zoneIds, setZoneIds] = useState<string[]>(filter.zoneIds);

  const onSearchChange = useInputOnChangeValue(setSearch);
  const onStatusChange = useSelectOnChangeValue(setStatus);
  const onZoneChange = useCallback((nextZoneIds: string[]) => {
    setZoneIds(nextZoneIds);
  }, []);

  useEffect(() => {
    setZoneIds(filter.zoneIds);
  }, [filter.zoneIds]);

  useEffect(() => {
    const debounce = setTimeout(() => {
      onChangeFilter((oldValue) => ({
        ...oldValue,
        search,
        publication_state_id: getPublicationStateIdFromStatus(status),
        zoneIds,
      }));
    }, 600);

    return () => {
      clearTimeout(debounce);
    };
  }, [search, status, zoneIds, onChangeFilter]);

  return {
    search,
    status,
    zoneIds,
    onSearchChange,
    onStatusChange,
    onZoneChange,
  };
};
